import { useParams } from 'react-router-dom';

export default function BoardView() {
    const { boardId } = useParams();

    return (
        <div style={{ padding: 24 }}>
            <h1>Board View (ID: {boardId})</h1>
            <p>Kanban implementation goes here.</p>
        </div>
    );
}
